import { MemberAddressInformationsFields } from './MemberAddressInformationForm.models';

export const addressInformationsInitState = {
  [MemberAddressInformationsFields.CorrespondenceAddressSameAsResidenceAddress]:
    true,
  [MemberAddressInformationsFields.ResidenceAddress]: {},
  [MemberAddressInformationsFields.CorrespondenceAddress]: {},
};
